
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MasterLicenseLayout from '@/components/masterlicense/MasterLicenseLayout';
import { useMasterLicense } from '@/hooks/useMasterLicense';
import MasterDashboardHeader from '@/components/masterlicense/dashboard/MasterDashboardHeader';
import MasterDashboardStats from '@/components/masterlicense/dashboard/MasterDashboardStats';
import RecentLicenseKeysCard from '@/components/masterlicense/dashboard/RecentLicenseKeysCard';
import DashboardTabs from '@/components/masterlicense/dashboard/DashboardTabs';
import { useToast } from '@/hooks/use-toast';
import { clearUserSession } from '@/utils/sessionManager';
import { MasterLicenseSettingsProvider } from '@/contexts/MasterLicenseSettingsContext';

const MasterLicenseDashboard = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);
  
  const {
    licenseKeys,
    filteredLicenseKeys,
    domains,
    superAdminLicenses,
    searchQuery,
    setSearchQuery,
    user
  } = useMasterLicense();

  const handleLogout = async () => {
    try {
      setIsLoading(true);
      console.log("Master Admin logout initiated");
      
      // Clear all user session data
      clearUserSession();
      
      toast({
        title: "Logged out",
        description: "You have been successfully logged out."
      });
      
      // Navigate to login page after logout
      window.location.href = '/login';
    } catch (error) {
      console.error('Error during logout:', error);
      toast({
        title: "Error",
        description: "Failed to log out. Please try again.",
        variant: "destructive"
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <MasterLicenseSettingsProvider isLoading={isLoading}>
      <MasterLicenseLayout
        isLoading={isLoading}
        onLogout={handleLogout}
        userRole={user?.role || 'Master Admin'}
        activeTab="dashboard"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <MasterDashboardHeader user={user as any} />
          
          <MasterDashboardStats 
            licenseKeys={licenseKeys} 
            domains={domains} 
            superAdminLicenses={superAdminLicenses} 
          />
          
          <RecentLicenseKeysCard 
            filteredLicenseKeys={filteredLicenseKeys} 
            searchQuery={searchQuery} 
            setSearchQuery={setSearchQuery} 
          />
          
          <DashboardTabs 
            domains={domains} 
            superAdminLicenses={superAdminLicenses} 
            licenseKeys={licenseKeys} 
          />
        </div>
      </MasterLicenseLayout>
    </MasterLicenseSettingsProvider>
  );
};

export default MasterLicenseDashboard;
